var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useMemo } from 'react';
import { OrderSummaryView } from './View';
import { useUser } from '../../../../../../context';
import { OrderStatus, } from 'types/codegen/hooks';
import { getLoyaltyLevel } from 'utils/getLoyaltyLevel';
export var OrderSummaryContainer = function (props) {
    var orderData = props.orderData, calculatedPricing = props.calculatedPricing;
    var _a = useUser(), account = _a.account, switchAccount = _a.switchAccount;
    var discounts = useMemo(function () {
        var _a, _b;
        return (_b = (_a = calculatedPricing === null || calculatedPricing === void 0 ? void 0 : calculatedPricing.inputDisplay) === null || _a === void 0 ? void 0 : _a.discounts) !== null && _b !== void 0 ? _b : null;
    }, [calculatedPricing]);
    var handleOrderCreate = function () { return __awaiter(void 0, void 0, void 0, function () {
        var subtotal, tax, totalDiscounts, order, currentQuarterLoyalty, newVialsPurchased, newLevel, updatedAccount;
        var _a;
        return __generator(this, function (_b) {
            subtotal = orderData.pricePerUnit * orderData.quantity;
            tax = subtotal * 0.0875;
            totalDiscounts = (orderData.quantity * 610) - subtotal;
            order = {
                id: Math.random().toString().replaceAll('.', ''),
                facility: orderData.facility,
                listPrice: orderData.quantity * 610,
                taxCharged: tax,
                totalCharged: subtotal + tax,
                totalEstimated: subtotal + tax,
                orderDate: new Date().toISOString(),
                subtotal: subtotal,
                totalDiscounts: totalDiscounts,
                status: OrderStatus.Accepted,
                lineItems: [{
                        id: 1,
                        product: {
                            pricePerUnit: orderData.pricePerUnit,
                            quantity: orderData.quantity,
                            sku: '123',
                        },
                        total: orderData.pricePerUnit * orderData.quantity,
                    }],
                shipping: {
                    address: orderData.facility.shippingAddress,
                    method: {
                        requestedDeliveryDate: new Date((_a = orderData === null || orderData === void 0 ? void 0 : orderData.shippingMethod) === null || _a === void 0 ? void 0 : _a.requestedDeliveryDate).toISOString(),
                        requestedDeliveryTime: new Date().toISOString(),
                        serviceName: 'FedEx',
                        fee: orderData.quantity > 5 ? 0 : 20,
                    },
                },
                billing: {
                    paymentMethod: orderData.paymentMethod[0],
                },
                discounts: calculatedPricing.discounts,
            };
            currentQuarterLoyalty = account === null || account === void 0 ? void 0 : account.currentQuarterLoyalty;
            newVialsPurchased = ((currentQuarterLoyalty === null || currentQuarterLoyalty === void 0 ? void 0 : currentQuarterLoyalty.vialsPurchased) || 0) + orderData.quantity;
            newLevel = getLoyaltyLevel(newVialsPurchased, currentQuarterLoyalty.levels);
            updatedAccount = __assign(__assign({}, account), { orders: __spreadArray(__spreadArray([], __read((account.orders || [])), false), [order], false), currentQuarterLoyalty: __assign(__assign({}, currentQuarterLoyalty), { pricedWith: {
                        "level": newLevel.name,
                        "quarterId": "2024Q1",
                    }, vialsPurchased: newVialsPurchased }) });
            switchAccount(updatedAccount);
            localStorage.setItem(account.id, JSON.stringify(updatedAccount));
            return [2, {
                    order: order,
                    orderDisplay: order,
                }];
        });
    }); };
    return (React.createElement(OrderSummaryView, __assign({}, props, { pageLoading: false, error: undefined, anyLoading: false, currentQuarterLoyalty: account === null || account === void 0 ? void 0 : account.currentQuarterLoyalty, discounts: discounts, onCreate: handleOrderCreate })));
};
